import { render, staticRenderFns } from "./err.vue?vue&type=template&id=af33a620&scoped=true"
import script from "./err.vue?vue&type=script&lang=js"
export * from "./err.vue?vue&type=script&lang=js"
import style0 from "./err.vue?vue&type=style&index=0&id=af33a620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af33a620",
  null
  
)

export default component.exports